import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import toast from "react-hot-toast";
import { VerifyToken } from "../../_api/Admin";
import { Button } from "../../_helpers/components/Button";
import { useNavigate } from "react-router-dom";

const VerifyEmail = () => {
    const { token } = useParams();

    const [isValid, setIsValid] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isValid) {
            getVerify();
        }
    }, []);

    async function getVerify() {
        await VerifyToken(token)
            .then(({ data }) => {
                setIsValid(true);
                toast(data.message);
            })
            .catch((resp) => {
                setIsValid(false);
                toast(resp.response.data.message);
            });
    }

    return (
        <>
            <div className="w-full lg:w-1/2 flex justify-center items-center gap-4">
                <div className="bg-white p-4 rounded-lg shadow-md w-3/4 max-w-md">
                    {isValid ? (
                        <p>Votre email a bien été confirmé !</p>
                    ) : (
                        <p>Une erreur s&#039;est produite.</p>
                    )}
                </div>
                <Button
                    action={() => {
                        navigate("/login");
                    }}
                    name={"Se connecter"}
                    type={"empty"}
                />
            </div>
        </>
    );
};
export default VerifyEmail;
